<div class="fem-modal">
  <div class="fem-modal__qr">
    <app-am-qrcode
      [qrdata]="femUrl"
      [width]="250"
      [errorCorrectionLevel]="'Q'"
      [margin]="4"
    ></app-am-qrcode>
  </div>

  <p class="fem-modal__subtitle">{{ 'fem.subtitle' | translate }}</p>
  <h2 class="fem-modal__title">{{ 'fem.title' | translate }}</h2>
  <p class="fem-modal__description">{{ 'fem.description' | translate }}</p>

  <div class="fem-modal__actions">
    <button
      class="fem-modal__button"
      type="button"
      (click)="onContinue()">
      {{ 'fem.' + buttonTextKey | translate }}
    </button>
  </div>
</div>
